import { Theme as MuiTheme, styled } from "@mui/material/styles";
import Switch, { SwitchProps } from "@mui/material/Switch";

import { colors } from "@dotnet/telematics-design-system";

import { SwitchThumbVectorIcon } from "../../../assets/customIcons/switch/SwitchThumbVectorIcon";
import { SwitchThumbVectorIconOn } from "../../../assets/customIcons/switch/SwitchThumbVectorIconOn";
import { generateCustomSwitchStyle } from "../styleFunctions";
import { TOGGLE_SWITCH_LABEL_PLACEMENT, TOGGLE_SWITCH_SIZES } from "../types";

interface CustomSwitchProps extends Omit<SwitchProps, "size"> {
  customSize: TOGGLE_SWITCH_SIZES;
  labelPlacement?: TOGGLE_SWITCH_LABEL_PLACEMENT;
}

interface ToggleSwitchSizeConfig {
  rootWidth: string;
  rootHeight: string;
  thumbSize: string;
  thumbCheckedTransform: string;
}

interface ToggleSwitchSizes {
  [TOGGLE_SWITCH_SIZES.Large]: ToggleSwitchSizeConfig;
  [TOGGLE_SWITCH_SIZES.Medium]: ToggleSwitchSizeConfig;
  [TOGGLE_SWITCH_SIZES.Small]: ToggleSwitchSizeConfig;
}

const sizes: ToggleSwitchSizes = {
  [TOGGLE_SWITCH_SIZES.Large]: {
    rootWidth: "48px",
    rootHeight: "24px",
    thumbSize: "22px",
    thumbCheckedTransform: "translateX(24px)"
  },
  [TOGGLE_SWITCH_SIZES.Medium]: {
    rootWidth: "36px",
    rootHeight: "20px",
    thumbSize: "18px",
    thumbCheckedTransform: "translateX(16px)"
  },
  [TOGGLE_SWITCH_SIZES.Small]: {
    rootWidth: "30px",
    rootHeight: "16px",
    thumbSize: "14px",
    thumbCheckedTransform: "translateX(14px)"
  }
};

export const CustomSwitch = styled(
  ({ customSize, labelPlacement, ...restProps }: CustomSwitchProps) => {
    const switchSize = sizes[customSize];

    return (
      <Switch
        disableRipple
        {...restProps}
        checkedIcon={
          <SwitchThumbVectorIconOn
            sx={{
              fontSize: switchSize.thumbSize,
              color: restProps.disabled ? colors.gray400 : colors.blue700
            }}
            hideVector={customSize === TOGGLE_SWITCH_SIZES.Small}
          />
        }
        icon={
          <SwitchThumbVectorIcon
            sx={{
              fontSize: switchSize.thumbSize,
              color: restProps.disabled ? colors.gray400 : colors.blue500
            }}
            hideVector={customSize === TOGGLE_SWITCH_SIZES.Small}
          />
        }
      />
    );
  }
)(({ customSize, labelPlacement }: CustomSwitchProps & { theme: MuiTheme }) =>
  generateCustomSwitchStyle({
    size: customSize,
    sizes,
    labelPlacement
  })
);
